type SelectorItemData = {
  label: string;
};

export type { SelectorItemData };
